<script>
	export default {
		props: {
			data: {
				type: Object,
				required: true
			},
			errorForm: {
				type: Boolean,
				required: true
			}
		},	
		methods: {
			key_press_rut(e) {
				let char = String.fromCharCode(e.keyCode);
				if (/^[0-9Kk.-]/.test(char)) return true;
				else e.preventDefault();
			},
			format_rut: function () {
				let value = this.data.value;
				this.data.value = value.replace(/[.-]/g, "").replace(/^(\d{1,2})(\d{3})(\d{3})(\w{1})$/, "$1.$2.$3-$4");
				if(value.length === 12 && /^[0-9Kk.-]/.test(value)) {
					this.data.error = false;
				}
				if(value.length !== 12 || /[A-JL-Z]/.test(value) || !/[.-]/.test(value)) {
					this.data.error = true;
				}
			},
		},
	}
</script>

<template>
	<div>
		<label class="form-label text-secondary">
			{{ data.label }}
		</label>
		<input
			type="text"
			maxlength="12"
			autocomplete="off"
			v-model.trim="data.value"
			@input="format_rut"
			@keypress="key_press_rut($event)"
			:class="{'is-invalid': data.error && errorForm }"
			class="form-control input-custom"
			placeholder="Ej: 12.345.678-9"
		/>
		<div class="invalid-feedback">
			Debes agregar un RUT válido.
		</div>
	</div>
</template>